import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { whyUs } from '../mockData';

const HomePage = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  const heroSlides = [
    {
      title: "Tüm Varlıkların Tek Ekranda, Kontrol Sende!",
      description: "Yeni nesil yatırım dünyasını keşfet. Piyasaları anlık takip et, portföyünü dilediğin yerden yönet ve finansal özgürlüğüne adım at.",
      cta: "HESAP AÇ",
      image: "https://customer-assets.emergentagent.com/job_colendi-replica/artifacts/2ci1gw2m_x.png"
    },
    {
      title: "Profesyonel Yatırım Platformu",
      description: "Uygulamayı indir, görüntülü görüşme ile dilediğin yerden anında yatırımcı ol.",
      cta: "HESAP AÇ",
      image: "https://customer-assets.emergentagent.com/job_colendi-replica/artifacts/2ci1gw2m_x.png"
    }
  ];

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % heroSlides.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + heroSlides.length) % heroSlides.length);
  };

  return (
    <div className="min-h-screen">
      {/* Hero Slider */}
      <section className="relative overflow-hidden min-h-[500px]" style={{ backgroundColor: '#ffffff' }}>
        {/* Single Animated Pattern - Moving Right to Left */}
        <div className="absolute top-1/2 -translate-y-1/2 pointer-events-none opacity-20" 
             style={{
               animation: 'slideRightToLeft 20s linear infinite',
               width: '100%',
               height: '300px'
             }}>
          <img 
            src="https://customer-assets.emergentagent.com/job_colendi-replica/artifacts/veaqlo0b_Untitled-4.jpg" 
            alt="" 
            className="h-full object-contain"
          />
        </div>
        
        <style>{`
          @keyframes slideRightToLeft {
            0% {
              transform: translateX(100%) translateY(-50%);
            }
            100% {
              transform: translateX(-100%) translateY(-50%);
            }
          }
        `}</style>
        
        <div className="container mx-auto px-4 py-10 relative z-10">
          <div className="grid lg:grid-cols-2 gap-8 items-center">
            {/* Left Content */}
            <div className="max-w-lg space-y-6">
              <h1 className="text-2xl lg:text-3xl font-bold text-gray-900 leading-tight tracking-tight" style={{ fontFamily: 'Arial, sans-serif', fontStretch: 'condensed' }}>
                Tüm Varlıkların Tek Ekranda,<br />
                Kontrol Sende!
              </h1>
              
              <p className="text-sm text-gray-700 leading-relaxed">
                Yeni nesil yatırım dünyasını keşfet. Piyasaları anlık takip et, portföyünü dilediğin yerden yönet ve finansal özgürlüğüne adım at.
              </p>
              
              <div className="space-y-3">
                <p className="text-sm text-gray-700 leading-relaxed">
                  Uygulamayı indir,<br />
                  görüntülü görüşme ile dilediğin yerden anında yatırımcı ol.
                </p>
                
                <a
                  href="https://my.scuzdan.com/login"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-block px-8 py-2.5 bg-black text-white font-bold rounded-full hover:bg-gray-800 transition-colors text-xs uppercase tracking-wide"
                >
                  HESAP AÇ
                </a>
              </div>
            </div>
            
            {/* Right Content - Phone Mockup - Smaller */}
            <div className="relative flex justify-center lg:justify-end">
              <img 
                src={heroSlides[currentSlide].image} 
                alt="Mobile App" 
                className="w-full max-w-[220px] lg:max-w-[260px] drop-shadow-2xl"
              />
            </div>
          </div>
        </div>
        
        {/* Slider Controls */}
        <div className="absolute bottom-6 left-1/2 transform -translate-x-1/2 flex items-center space-x-3 z-20">
          <button 
            onClick={prevSlide}
            className="p-1.5 bg-white rounded-full shadow-md hover:bg-gray-50 transition-colors border border-gray-200"
          >
            <ChevronLeft size={18} className="text-gray-700" />
          </button>
          <div className="flex items-center space-x-1.5">
            {heroSlides.map((_, index) => (
              <button
                key={index}
                onClick={() => setCurrentSlide(index)}
                className={`h-1.5 rounded-full transition-all ${
                  currentSlide === index ? 'bg-teal-600 w-5' : 'bg-gray-400 w-1.5'
                }`}
              />
            ))}
          </div>
          <button 
            onClick={nextSlide}
            className="p-1.5 bg-white rounded-full shadow-md hover:bg-gray-50 transition-colors border border-gray-200"
          >
            <ChevronRight size={18} className="text-gray-700" />
          </button>
        </div>
      </section>

      {/* Services Section */}
      <section className="py-12 relative" style={{ 
        background: `linear-gradient(to bottom, #f3f4f6 0%, #f3f4f6 60%, #000000 60%, #000000 100%)`
      }}>
        <div className="container mx-auto px-4">
          <h2 className="text-3xl font-bold mb-10 text-gray-900" style={{ fontFamily: 'Arial, sans-serif', fontStretch: 'condensed' }}>
            Hizmetler
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {/* VİOP İŞLEMLERİ */}
            <Link
              to="/hizmetler/viop-islemleri"
              className="group bg-white rounded-2xl overflow-hidden hover:shadow-2xl transition-all duration-300 hover:-translate-y-2"
            >
              <div className="h-1 bg-gradient-to-r from-pink-400 to-pink-500"></div>
              <div className="p-8 text-center">
                <div className="flex justify-center mb-6">
                  <img 
                    src="https://customer-assets.emergentagent.com/job_colendi-replica/artifacts/qih3ju09_viop.png" 
                    alt="VİOP İşlemleri"
                    className="w-24 h-24 object-contain"
                  />
                </div>
                <h3 className="text-lg font-bold text-gray-900 mb-8 uppercase tracking-tight">
                  VİOP İŞLEMLERİ
                </h3>
                <div className="pt-4 border-t border-gray-200">
                  <span className="text-sm font-medium text-gray-900">Hemen İncele</span>
                </div>
              </div>
            </Link>

            {/* PAY ALIM-SATIM */}
            <Link
              to="/hizmetler/pay-alim-satim"
              className="group bg-white rounded-2xl overflow-hidden hover:shadow-2xl transition-all duration-300 hover:-translate-y-2"
            >
              <div className="h-1 bg-gradient-to-r from-yellow-400 to-yellow-500"></div>
              <div className="p-8 text-center">
                <div className="flex justify-center mb-6">
                  <img 
                    src="https://customer-assets.emergentagent.com/job_colendi-replica/artifacts/941o2s4c_payalim.png" 
                    alt="Pay Alım-Satım"
                    className="w-24 h-24 object-contain"
                  />
                </div>
                <h3 className="text-lg font-bold text-gray-900 mb-8 uppercase tracking-tight">
                  PAY ALIM-SATIM
                </h3>
                <div className="pt-4 border-t border-gray-200">
                  <span className="text-sm font-medium text-gray-900">Hemen İncele</span>
                </div>
              </div>
            </Link>

            {/* YATIRIM DANIŞMANLIĞI */}
            <Link
              to="/hizmetler/yatirim-danismanligi"
              className="group bg-white rounded-2xl overflow-hidden hover:shadow-2xl transition-all duration-300 hover:-translate-y-2"
            >
              <div className="h-1 bg-gradient-to-r from-purple-400 to-purple-500"></div>
              <div className="p-8 text-center">
                <div className="flex justify-center mb-6">
                  <img 
                    src="https://customer-assets.emergentagent.com/job_colendi-replica/artifacts/gokfabac_ytd.png" 
                    alt="Yatırım Danışmanlığı"
                    className="w-24 h-24 object-contain"
                  />
                </div>
                <h3 className="text-lg font-bold text-gray-900 mb-8 uppercase tracking-tight">
                  YATIRIM DANIŞMANLIĞI
                </h3>
                <div className="pt-4 border-t border-gray-200">
                  <span className="text-sm font-medium text-gray-900">Hemen İncele</span>
                </div>
              </div>
            </Link>

            {/* YATIRIM FONLARI */}
            <Link
              to="/hizmetler/yatirim-fonlari"
              className="group bg-white rounded-2xl overflow-hidden hover:shadow-2xl transition-all duration-300 hover:-translate-y-2"
            >
              <div className="h-1 bg-gradient-to-r from-cyan-400 to-cyan-500"></div>
              <div className="p-8 text-center">
                <div className="flex justify-center mb-6">
                  <img 
                    src="https://customer-assets.emergentagent.com/job_colendi-replica/artifacts/f4p0nkgh_ytf.png" 
                    alt="Yatırım Fonları"
                    className="w-24 h-24 object-contain"
                  />
                </div>
                <h3 className="text-lg font-bold text-gray-900 mb-8 uppercase tracking-tight">
                  YATIRIM FONLARI
                </h3>
                <div className="pt-4 border-t border-gray-200">
                  <span className="text-sm font-medium text-gray-900">Hemen İncele</span>
                </div>
              </div>
            </Link>
          </div>
        </div>
      </section>

      {/* Platforms Showcase Section */}
      <section className="py-16 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            {/* Left Content */}
            <div className="space-y-8">
              <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 leading-tight" style={{ fontFamily: 'Arial, sans-serif', fontStretch: 'condensed' }}>
                Dilediğiniz Zaman<br />
                Borsa İstanbul Hisse<br />
                Senetlerine<br />
                İşlem Yapın.
              </h2>
            </div>
            
            {/* Right Content - Phone Mockups */}
            <div className="relative flex justify-center lg:justify-end">
              <img 
                src="https://customer-assets.emergentagent.com/job_colendi-replica/artifacts/2ci1gw2m_x.png" 
                alt="Mobile App" 
                className="w-full max-w-lg drop-shadow-2xl"
              />
            </div>
          </div>
          
          {/* Button */}
          <div className="flex justify-center mt-12">
            <a
              href="https://my.scuzdan.com/register"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block px-12 py-4 bg-black text-white font-bold rounded-full hover:bg-gray-800 transition-colors text-sm uppercase tracking-wider"
            >
              HESAP OLUŞTUR
            </a>
          </div>
        </div>
      </section>

      {/* Why Us Section */}
      <section className="py-16 bg-gray-50">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl font-bold text-center mb-12 text-gray-900">Neden CLND Menkul?</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {whyUs.map((item) => (
              <div key={item.id} className="bg-white rounded-lg p-8 text-center hover:shadow-xl transition-shadow">
                <img src={item.image} alt={item.title} className="w-24 h-24 mx-auto mb-6" />
                <h3 className="text-xl font-bold text-gray-900 mb-4">{item.title}</h3>
                <p className="text-gray-600 leading-relaxed">{item.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default HomePage;